<template>
  <button
    type="button"
    @click="toggleTheme"
    :title="isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'"
    :aria-label="isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'"
    class="relative p-2 text-slate-600 dark:text-slate-300 hover:text-indigo-600 dark:hover:text-indigo-400 hover:bg-slate-100 dark:hover:bg-slate-800/70 rounded-xl flex items-center justify-center transition-all duration-150 border border-transparent hover:border-slate-200/80 dark:hover:border-slate-800 focus:outline-none cursor-pointer"
  >
    <!-- Sun icon for Dark Mode -->
    <Sun
      v-if="isDark"
      class="w-4 h-4 sm:w-5 sm:h-5 text-amber-400 transition-transform duration-300 transform rotate-0 hover:rotate-45"
    />
    <!-- Moon icon for Light Mode -->
    <Moon
      v-else
      class="w-4 h-4 sm:w-5 sm:h-5 text-indigo-600 dark:text-indigo-400 transition-transform duration-300 transform -rotate-12 hover:rotate-0"
    />
  </button>
</template>

<script setup>
import { Sun, Moon } from "lucide-vue-next";
import { useTheme } from "@/composables/useTheme";

const { isDark, toggleTheme } = useTheme();
</script>
